import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "px-6 py-16 sm:py-20 text-center" }
const _hoisted_2 = { class: "text-slate-900 font-bold text-lg mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-slate-500 text-sm mb-5 max-w-md mx-auto"
}

import AdminButton from "@/share/components/admin/AdminButton.vue";

interface Props {
  error?: unknown;
  title?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorState',
  props: {
    error: {},
    title: { default: "Error al cargar los datos" }
  },
  emits: ["retry"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4" }, [
      _createElementVNode("svg", {
        class: "w-8 h-8 text-red-600",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })
      ])
    ], -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
    (__props.error && typeof __props.error === 'object' && 'message' in __props.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(String((__props.error as { message?: string }).message)), 1))
      : _createCommentVNode("", true),
    _createVNode(AdminButton, {
      variant: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retry')))
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode(" Reintentar ", -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})